import modular from 'modujs';
import * as modules from './modules';
import globals from './globals';
import { html } from './utils/environment';

const app = new modular({
    modules: modules
});

window.isMobile = (/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

if(window.isMobile) {
    html.classList.add('is-mobile');
}

window.onload = (event) => {
    const $style = document.getElementById("stylesheet");

    if ($style.isLoaded) {
        init();
    } else {
        $style.addEventListener('load', (event) => {
            init();
        });
    }
};

function init() {
    app.init(app);
    globals();

    html.classList.add('is-loaded','is-ready');
    html.classList.remove('is-loading');

    setTimeout(() => {
        html.classList.add('is-first-load');
        html.classList.add('has-dom-ready');

        setTimeout(() => {
            html.classList.add('is-animated');
        }, 1200);
    }, 1200);


    // Bind events
    bindEvents()
}

////////////////
// Global events
////////////////
function bindEvents() {

    if (window.isMobile) {
        console.log("isMobile")
        window.addEventListener("resize", () => {
            onMobileResize();
        });
    } else {
        // Resize event
        window.addEventListener("resize", () => {
            onResize();
        });
    }
}


function onResize() {
    let vw = html.offsetWidth * 0.01;
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vw", `${vw}px`);
    document.documentElement.style.setProperty("--vh", `${vh}px`);
}

function onMobileResize() {
    if(window.innerWidth > window.innerHeight && window.customOrientation != "landscape") {
        window.customOrientation = "landscape"
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);
    }

    if(window.innerWidth < window.innerHeight && window.customOrientation != "portrait") {
        window.customOrientation = "portrait"
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);
    }
}
